<template>
    <div class="nosotros" style=" max-width: 100vw; overflow: hidden;" >
        <meta http-equiv=”Content-Type” content=”text/html; charset=UTF-8″ />
        <Navbar />
        <link rel="stylesheet" href="https://unpkg.com/vue-agile/dist/VueAgile.css">
        <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/animate.css/4.1.1/animate.min.css" />
        <section id="section-banner-adn" class="nosotros-banner">
            <div class="container">
                <div class="row d-flex justify-content-center">
                    <div class="col-9 text-center ajuste-textos animate__animated animate__fadeInLeft">
                        <h1 class="textos subtitulos-principales blanco bold">MÁS QUE ADN, UNA FILOSOFÍA DE VIDA</h1>
                        <p class="textos subtitulos-intermedios-sec-ajustes light blanco pb-md-3">
                            Toda nuestra experiencia, servicios y tecnología no serían nada sin un propósito y una manera de cumplirlo.
                        </p>
                    </div>
                </div>
            </div>
        </section>

        <section id="flechas-generales">
            <div class="flecha-down wow animate_animated animate_fadeInDown animate_infinite infinite animate_slow">
                <img src="../assets/home/flecha-abajo.png" alt="">
            </div>
        </section>

        <section>
            <div class="container-fluid">
                <div class="row d-flex align-items-center">
                    <div class="col-12 col-md-6 p-5">
                        <p class="textos section-historia-secundarios light negro py-md-2 text-justify"><span class="textos section-historia-secundarios bold rojo">SOMOS</span> el resultado de años y años de vivencias que nos permiten comprender de manera humana el sentir y las necesidades de nuestros clientes para poder brindar un servicio extraordinario y efectivo. </p>
                        <p class="textos section-historia-secundarios light negro py-md-2 text-justify"><span class="textos section-historia-secundarios bold rojo">SOMOS</span> las ganas de vivir tranquilos y seguros… de compartir y promover eso con todos nuestros clientes y colaboradores.</p>
                    </div>
                    <div class="col-12 col-md-6 text-right">
                        <img src="../assets/adn/somos.png" class="img-fluid" alt="">
                    </div>
                </div>
            </div>
        </section>

        <section id="section-mision" class="mission-textura">
            <div class="container py-md-5 py-5">
                <div class="row py-md-5 py-5 d-flex justify-content-center">
                    <div class="col-md-6 text-center bordes py-md-3 py-3">
                        <h3 class="textos subtitulos-intermedios bold amarillo">MISIÓN</h3>
                        <p class="textos parrafos-principales light blanco py-md-2">Ayudamos a recuperar la tranquilidad y seguridad de nuestros clientes.</p>
                    </div>
                    <div class="col-md-6 text-center py-md-3 py-3">
                        <h3 class="textos subtitulos-intermedios bold amarillo">VISIÓN</h3>
                        <p class="textos parrafos-principales light blanco py-md-2">Ser la empresa referente del mercado de servicios asistenciales más vanguardista, adaptable y ágil, presente siempre en la mente de nuestros clientes como la mejor opción.</p>
                    </div>
                </div>
            </div>
        </section>

        <section>
            <div class="container">
                <div class="row d-flex justify-content-center">
                    <div class="col-md-10 text-center">
                        <h2 class="textos subtitulos-intermedios azul bold py-4">NOS MOVEMOS BAJO 4 PRINCIPIOS</h2>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12">
                        <!-- Carousel Start -->

                        <agile :initial-slide="0" :autoplay="true" :dots="true">
                            <div class="slide">
                                <div class="row d-flex justify-content-center align-items-center my-2">
                                    <div class="col-md-4">
                                        <img src="../assets/adn/iconos/1adn.png" class="img-fluid desktop-img-vector" width="100%" alt="">
                                    </div>
                                    <div class="col-md-5 section-slider-nosotros">
                                        <h3 class="textos section-historia-secundarios rojo bold text-start-mobile">NOS APASIONA AYUDARTE</h3>
                                        <p>
                                            <ul>
                                                <li class="textos parrafos-intermedios light negro">Respondemos con verdad y certeza </li>
                                                <li class="textos parrafos-intermedios light negro">Demostramos con hechos nuestra calidad </li>
                                                <li class="textos parrafos-intermedios light negro">Solucionamos con experiencias positivas </li>
                                                <li class="textos parrafos-intermedios light negro">Siempre buscamos hacerlo posible</li>
                                            </ul>
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div class="slide">
                                <div class="row d-flex justify-content-center align-items-center my-2">
                                    <div class="col-md-4">
                                        <img src="../assets/adn/iconos/2adn.png" class="img-fluid desktop-img-vector" width="100%" alt="">
                                    </div>
                                    <div class="col-md-5 section-slider-nosotros">
                                        <h3 class="textos section-historia-secundarios rojo bold  text-start-mobile ">UNIDOS LOGRAMOS MÁS</h3>
                                        <p>
                                            <ul>
                                                <li class="textos parrafos-intermedios light negro">Comunicamos eficientemente</li>
                                                <li class="textos parrafos-intermedios light negro">Trabajamos en conjunto</li>
                                                <li class="textos parrafos-intermedios light negro">Reconocemos los logros</li>
                                                <li class="textos parrafos-intermedios light negro">Nos adaptamos con actitud positiva</li>
                                                <li class="textos parrafos-intermedios light negro">Cumplimos responsabilidades</li>
                                            </ul>
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div class="slide">
                                <div class="row d-flex justify-content-center align-items-center my-2">
                                    <div class="col-md-4">
                                        <img src="../assets/adn/iconos/3adn.png" class="img-fluid desktop-img-vector" width="100%" alt="">
                                    </div>
                                    <div class="col-md-5 section-slider-nosotros">
                                        <h3 class="textos section-historia-secundarios rojo bold text-start-mobile ">ÉTICA Y BIENESTAR</h3>
                                        <p>
                                            <ul>
                                                <li class="textos parrafos-intermedios light negro">Somos congruentes y honestos</li>
                                                <li class="textos parrafos-intermedios light negro">Cuidamos el bienestar de los demás</li>
                                                <li class="textos parrafos-intermedios light negro">Actuamos con empatía, ética y profesionalismo</li>
                                                <li class="textos parrafos-intermedios light negro">Nos dirigimos con libertad y respeto</li>
                                                <li class="textos parrafos-intermedios light negro">Cuidamos a la empresa y a nuestros clientes</li>
                                            </ul>
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div class="slide">
                                <div class="row d-flex justify-content-center align-items-center my-2">
                                    <div class="col-md-4">
                                        <img src="../assets/adn/iconos/4adn.png" class="img-fluid desktop-img-vector" width="100%" alt="">
                                    </div>
                                    <div class="col-md-5 section-slider-nosotros">
                                        <h3 class="textos section-historia-secundarios rojo bold text-start-mobile ">ESTAMOS SIEMPRE ADELANTE </h3>
                                        <p>
                                            <ul>
                                                <li class="textos parrafos-intermedios light negro">Innovamos y explotamos nuestro potencial</li>
                                                <li class="textos parrafos-intermedios light negro">Participamos activamente en la mejora </li>
                                                <li class="textos parrafos-intermedios light negro">Ejecutamos con rapidez y calidad </li>
                                                <li class="textos parrafos-intermedios light negro">Asumimos retos y responsabilidades</li>
                                                <li class="textos parrafos-intermedios light negro">Innovamos par crear valor</li>
                                            </ul>
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <template slot="prevButton">
                                <i class="fas fa-chevron-left"></i>
                            </template>
                            <template slot="nextButton">
                                <i class="fas fa-chevron-right"></i>
                            </template>
                        </agile>
                        <!-- Carousel End -->
                    </div>
                </div>
            </div>
        </section>
        <div class="my-5"></div>

        <section>
            <div class="container-fluid">
                <div class="row d-flex justify-content-center">
                    <div class="col-md-10 p-3 text-center">
                        <img src="../assets/adn/colage.png" class="img-fluid" alt="" width="100%">
                    </div>
                </div>
            </div>
        </section>

        <section id="section-descanso-adn" class="py-5">
            <div class="container py-5">
                <div class="row py-5">
                    <div class="col-md-12 text-center">
                        <h3 class="textos subtitulos-principales blanco semi-bold">La tranquilidad y seguridad son las bases del crecimiento.</h3>
                    </div>
                </div>
            </div>
        </section>

        <Footer />

    </div>
</template>

<script src="https://unpkg.com/vue-agile"></script>

<script>
    // @ is an alias to /src
    import Navbar from './shared/Navbar/Navbar.vue';
    import { VueAgile } from 'vue-agile';
    import Footer from './shared/footer/Footer.vue';

    export default {
        name: "Nosotros",
        components: {
            Navbar,
            agile: VueAgile,
            Footer
            
        },
        data() {
            return {
                newItem: "",
            }
        },
        mounted() {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    };
</script>

<style scoped>
    .section-slider-nosotros .text-start-mobile {
        text-align: left;
    }

    .section-slider-nosotros ul {
        padding: 0;
        list-style: none;
    }

        .section-slider-nosotros ul li {
            font-size: 18px;
        }

        .section-slider-nosotros ul li::before {
            content: "\2022";
            color: #FFDE17;
            font-weight: bold;
            display: inline-block;
            width: 20px;
            margin-left: -1em;
            font-size: 30px;
            margin: 0;
        }

    #section-descanso-adn {
        background-image: url('../assets/adn/parallax.png');
        background-attachment: fixed;
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
    }
    
</style>

<style>
    @import "../assets/template/css/textosF.css";
    @import "../assets/template/css/Icons.css";
    @import "../assets/template/css/generals.css";


    .nosotros-banner {
        min-height: 650px;
        background-size: cover;
        background-position: 50%;
        background-repeat: no-repeat;
        background-image: url("../assets/home/banner-nosotros-01.png");
    }

    .ajuste-textos {
        padding-top: 90px;
    }

    .mission-textura {
        background-image: url("../assets/adn/textura.png");
    }

    .section-historia-secundarios {
        font-size: 30px;
        line-height: 35px;
        font-family: "Poppins-Bold";
        text-align: left;
    }
    .agile__nav-button {
        background: transparent;
        border: none;
        color: #fff;
        cursor: pointer;
        font-size: 24px;
        height: 100%;
        position: absolute;
        top: 0;
        transition-duration: .3s;
        width: 80px;
    }

        .agile__nav-button:hover {
            background-color: rgba(0, 0, 0, 0.5);
            opacity: 1;
        }

    .agile__nav-button--prev {
        left: 0;
    }

    .agile__nav-button--next {
        right: 0;
    }

    .agile__dots {
        bottom: 10px;
        left: 50%;
        position: absolute;
        transform: translateX(-50%);
    }

    .agile__dot {
        margin: 0 10px;
    }

        .agile__dot button {
            background-color: #222424;;
            border: 1px solid #fff;
            border-radius: 50%;
            cursor: pointer;
            display: block;
            height: 10px;
            font-size: 0;
            line-height: 0;
            margin: 0;
            padding: 0;
            transition-duration: .3s;
            width: 10px;
            
        }

        .agile__dot--current button, .agile__dot:hover button {
            background-color: #b81c21!important;
        }

    .slide {
        display: block;
        height: auto;
        object-fit: cover;
        width: 100%;
    }

</style>
